import { createEntityAdapter } from "@reduxjs/toolkit";
import { ContactInformation } from "./dataTypes";

export const contactInformationAdapter = createEntityAdapter<ContactInformation>({});
